import React, { Component } from 'react';
import { MDBIcon } from 'mdbreact'

import ListVault from './listVault/index'
import Vault from '../addVault/Vault'
import Spinner from '../../../components/spinner/Spinner'


import FetchUserData from '../../../actions/fetchUserData'
import { connect } from 'react-redux'

class Sidenav extends Component {
    state = {}
    componentDidMount() {
        this.props.fetchUserData(this.props.user.uid)
    }
    state = {
        modal: false
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <div className="container mt-2">
                <div className="row d-flex justify-content-center">
                    <img src="https://dewey.tailorbrands.com/production/brand_version_mockup_image/570/1636416570_c005ae40-bc2c-42ec-9f8f-04402cdd063b.png?cb=1548832092" alt="" />
                </div>

                <div className="row mt-5 d-flex justify-content-between align-items-center" style={{ borderBottom: '1px solid black' }}>
                    <h3>
                        Vaults
                </h3>
                    <MDBIcon onClick={this.toggle} icon="plus-square" style={{ cursor: 'pointer', fontSize: '25px', color: 'red' }} />
                    <Vault modal={this.state.modal} toggle={this.toggle} />
                </div>
                <div className="row">
                    {
                        this.props.vaults.loading
                            ? <Spinner />
                            : this.props.vaults.vaults.length !== 0
                                ? <ListVault data={this.props.vaults.vaults} />
                                : this.props.vaults.vaults
                                    ? <p>you dont have vault yet, please create one</p>
                                    : null
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            user: state.userStatus,
            vaults: state.userData
        }
    )
}
const mapDispatchToProps = (dispatch) => {
    return {
        fetchUserData: (uid) => dispatch(FetchUserData(uid))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidenav);